module.exports = __webpack_public_path__ + "img/bg_video5.8433f1e1.png";